export default "__VITE_ASSET__Dx2$7VuP__";